import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { PartnerIntegrationState } from 'src/types/partner-integration';
import { connectPartnerIntegration, fetchPartnerIntegration } from 'src/redux/partner-integration/api';

const extraReducers = (builder: ActionReducerMapBuilder<PartnerIntegrationState>): void => {
  builder.addCase(fetchPartnerIntegration().pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(fetchPartnerIntegration().fulfilled, (state, action) => {
    state.isLoading = false;
    state.data = action?.payload as PartnerIntegrationState['data'];
  });
  builder.addCase(fetchPartnerIntegration().rejected, (state) => {
    state.isLoading = false;
  });

  // connecting partner
  builder.addCase(connectPartnerIntegration().fulfilled, (state) => {
    state.step = 'complete';
  });
  builder.addCase(connectPartnerIntegration().rejected, (state) => {
    state.step = 'error';
  });
};

export default extraReducers;
